import './css/Footer.css';

function Footer() {
  return (
    <div className="footer" >
      ©Copyright 2023 Gill Associates Photography
    </div>
  );
}

export default Footer;
